module.exports = {"152201001":"爱国街道","152201002":"和平街道","152201003":"兴安街道","152201004":"胜利街道","152201005":"铁西街道","152201006":"都林街道","152201007":"五一街道","152201008":"城郊街道","152201009":"新城街道","152201100":"乌兰哈达镇","152201101":"葛根庙镇","152201102":"太本站镇","152201103":"义勒力特镇","152201401":"呼和马场","152201402":"乌兰浩特绿色产业园","152201403":"兴安盟经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152201.json
// module id = 565
// module chunks = 0